import { Select as AntSelect } from "antd";
import PropTypes from "prop-types";
import { FAILURE_MODES, failureMode, withFailureMode } from "./step-tabs";

const FailureModeField = ({ config, labels, onChange }) => {
  const mode = failureMode(config);
  return (
    <div className="canvas-failure">
      <span className="canvas-failure__label">{labels.LABEL}</span>
      <AntSelect
        virtual={false}
        popupMatchSelectWidth={false}
        className="canvas-failure__select"
        aria-label={labels.LABEL}
        value={mode}
        options={[
          { value: FAILURE_MODES.STOP, label: labels.STOP },
          { value: FAILURE_MODES.CONTINUE, label: labels.CONTINUE },
        ]}
        onChange={(next) => onChange(withFailureMode(config, next))}
      />
    </div>
  );
};

FailureModeField.propTypes = {
  config: PropTypes.object,
  labels: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

FailureModeField.defaultProps = {
  config: {},
};

export default FailureModeField;
